import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import _ from "lodash";
import FETIASEntity from "../../business/FETIASEntity";

import { diff, patch } from 'jsondiffpatch'

import VueRouter from "vue-router";
Vue.use(VueRouter);

import commons from '../commons/commons';
import { commonStore } from "./commonStore";
import LocalStorageService from "./LocalStorageService";

let summ = function (expr, list) {
  return list.reduce(function (accumulator, row) {
    return accumulator + expr(row);
  }, 0);
}

export const classificationStore = new Vuex.Store({
  state: {
    ...commonStore.state,
    users: [],
    states: [],
    previousClone: null,
    submissionClone: null,
    interimClone: null,
    appliedChange: false,
    needSync: false,
    baseServer: "",
    form: null,
    originalForm: null,
    formData: null,
    formDesign: null,
    locusId: null,
    vectorId: null,
    vector: null,
    activityId: null,
    documentId: null,
    token: LocalStorageService.getAccessToken(),
    currentUsername: null,
    query: null,
    initial: null,
    synchronizing: false,
    backendTriggers: null,
    frontTriggers: null,
    syncError: false,
    syncErrorRetry: 0,
    syncLastTime: null,
    activityName: null,
    workspace: null,
    polling: null,
  },
  watch: {
    formData(newValue, oldValue) {
      //   handler: function() {
      console.log("change");
      //   },
      //   deep: true
    }
  },
  mutations: {
    ...commonStore.mutations,
    setup(state, data) {
      if (data.baseServer) state.baseServer = data.baseServer;
      if (data.formData) state.formData = data.formData;

      state.locusId = data.locusId;
      state.vectorId = data.vectorId;
      state.activityId = data.activityId;
      state.users = data.users;
      state.query = data.query;
      state.initial = true;

      if (localStorage['ls.authorizationData']) {
        state.currentUsername = JSON.parse(localStorage['ls.authorizationData']).userName;
      }
    },
    setupList(state, data) {
      if (data.baseServer) state.baseServer = data.baseServer;
      // state.token = data.token;
      state.workspace = data.workspace;
      state.client.defaults.headers['workspace'] = state.workspace;

      if (data.vector) state.vectorId = data.vector;
    },
    setServer(state, data) {
      if (data.baseServer != null) state.baseServer = data.baseServer;
    },
    setVector(state, data) {
      if (data.vectorId != null) {
        state.vectorId = data.vectorId;
        state.vector = {
          id: data.vectorId,
          name: data.vectorName,
          emoji: data.vectorEmoji
        }
      }
    },
    setVectorId(state, data) {
      state.vectorId = data;
    },
    setWorkspace(state, data) {
      state.workspace = data
      state.client.defaults.headers['workspace'] = state.workspace;
    },
    basicSetup(state, data) {
      state.baseServer = data.baseServer;
      // state.token = data.token;
      state.documentId = data.documentId;
      state.vectorId = data.vectorId;
    },
    loadForm(state, form) {
      state.syncLastTime = new Date()
      state.previousClone = null;
      state.form = form;
      state.originalForm = null;
      state.documentId = null;
    },
    loadFormData(state, formData) {
      state.formData = formData;
    },
    updateDocumentId(state, payload) {
      if (payload) {
        state.documentId = payload.documentId;
        state.vectorId = payload.vectorId;
      } else {
        state.documentId = null;
      }

    },
    syncFormData(state, formData) {
      state.syncLastTime = new Date()
      state.appliedChange = true;
      state.formData = formData;
    },
    updateForm(state, form) {
      if (!state.originalForm) {
        state.originalForm = state.form;
      }

      state.form = form;
    },
    revertForm(state) {
      state.form = state.originalForm;
    },
    syncTriggers(state, data) {
      state.frontTriggers = data.frontTriggers;
      state.backendTriggers = data.backendTriggers;
    },
    storeFormDesign(state, formDesign) {
      state.formDesign = formDesign;
      state.vectorId = formDesign.vectorId;
      state.needSync = formDesign.needSync;
    },
    setNeedSync(state, needSync) {
      state.needSync = needSync;
    },
    resetApplyChange(state) {
      state.appliedChange = false;
    },
    setUsers(state, users) {
      state.users = users;
    },
    setStates(state, states) {
      state.states = states
    },
    setPolling(state, polling) {
      state.polling = polling;
    }
  },
  getters: {
    formData: state => state.formData,
    uploadFormData: (state) => (payload) => {
      return {
        vectorId: state.vectorId,
        fieldName: payload.fieldName,
        fieldId: payload.fieldId,
        type: payload.formType,
        workDesignId: state.formDesign ? state.formDesign.workDesignId : null
      };
    },
    syncError: state => state.syncError,
    currentUserProfileUrl: (state) => {
      var user = state.users.find(x => x.userName == state.currentUsername);
      if (
        user &&
        user.profilePictureUrl &&
        user.profilePictureUrl.indexOf("ProfilePics") > -1
      ) {
        return state.baseServer + user.profilePictureUrl;
      }

      return '';
    }
  },
  actions: {
    ...commonStore.actions,
    polling(context, payload) {
      context.commit('setPolling', payload.polling);
    },
    setUsers(context, payload) {
      let users = payload.users.map((x) => (
        Object.assign(x, {
          username: x.username || x.userName
        })
      ))

      context.commit("setUsers", users);
    },
    setStates(context, payload) {
      context.commit("setStates", payload);
    },
    resetApplyChange(context) {
      context.commit("resetApplyChange");
    },
    setBaseServer(context, payload) {
      context.commit('setServer', payload);
    },
    setVector(context, payload) {
      context.commit('setVector', payload);
    },

    setWorkspace({ commit }, payload) {
      commit('setWorkspace', payload)
    },
    basicSetup(context, payload) {
      context.commit('basicSetup', payload);
    },
    setFormData(context, payload) {
      context.commit("loadFormData", payload);
    },
    resetActivityForm(context) {
      context.commit("loadForm", { rows: [{ items: [] }] });
      context.commit("loadFormData", {});
    },
    async loadDocumentForm(context, payload) {
      let res = await context.state.client.post(`/api/Activity/Form`, payload);
      return res;
    },
    async loadDocumentLegacy(context, payload) {
      let res = await context.state.client.get(payload.url);
      return res;
    },
    async loadViewForm(context, payload) {
      let res = await context.state.client.post(`/api/Activity/Form`, {
        locusId: payload.locusId,
        activityId: payload.activityId,
        listingId: payload.listingId
      })

      return {
        viewData: {
          form: res.data.classificationForm.design,
          formData: res.data.classificationForm.default
        },
        header: res.data.header,
        footer: res.data.footer
      };
    },
    async loadActivityForm(context, payload) {
      context.state.syncError = false;
      context.commit("setNeedSync", false);
      context.commit("setup", payload);
      context.state.synchronizing = true;

      context.commit("loadForm", { rows: [{ items: [] }] });
      context.commit("loadFormData", {});

      let res = await context.state.client.post(`/api/Activity/Form`, {
        vectorId: context.state.vectorId,
        locusId: context.state.locusId,
        activityId: payload.activityId,
        listingId: payload.listingId,
        query: payload.query
      })
      
      if (res.data.header && res.data.header.moduleId) {
        context.commit("setVectorId", res.data.header.moduleId);
      }

      if (res.data.classificationForm) {
        if (payload.username) {
          res.data.classificationForm.default['username'] = payload.username;

          var user = context.state.users.find(x => x.username == payload.username);
          if (user) {
            res.data.classificationForm.default['name'] = user.displayName;
          }
        }

        context.commit("loadForm", res.data.classificationForm.design);
        context.commit("loadFormData", res.data.classificationForm.default);
        context.commit("syncTriggers", res.data.classificationForm);
        context.state.previousClone = _.cloneDeep(res.data.classificationForm.default);

        context.state.activityId = payload.activityId;
        context.state.activityName = payload.activity;
        context.commit("setNeedSync", res.data.classificationForm.needSync);
      }

      context.state.synchronizing = false;

      return {
        needSync: context.state.needSync,
        header: res.data.header,
        footer: res.data.footer
      };
    },
    async searchEntry(context, payload) {
      if (context.state.documentId) {
        payload.documentId = context.state.documentId;
      }

      var result = await context.state.client
        .post("/api/Activity/FormSelection", payload);
      return result;
    },
    cartToForm(context, payload) {
      //find form field,
      let rows = this.formData[payload.fields[0].fieldName];
      payload.items.forEach(item => {
        rows.push({
          id: commons.newUUID(),
        });
      });

    },
    eventTriggered(context, payload) {
      this.dispatch('synchronize', {
        eventName: payload.eventName,
        activity: payload.activity
      })
    },
    async synchronize(context, payload) {
      console.log(`synchronize: ${payload.polling}, current: ${context.state.polling}`);

      if (payload.polling != context.state.polling && !payload.eventName) {
        console.log('secondary clear');
        clearInterval(payload.polling);
        return;
      }

      let backendTriggers = context.state.backendTriggers;
      let frontTriggers = context.state.frontTriggers;
      let sendBack = false;

      let inputFields = commons.getAllElements(null, context.state.form);

      let currentClassification = new FETIASEntity(context.state.formData, inputFields);
      let previousClassification = new FETIASEntity(context.state.previousClone, inputFields);
      let interimClassification = new FETIASEntity(context.state.interimClone, inputFields);
      let formData = currentClassification;

      if (backendTriggers != null && context.state.previousClone != null) {
        sendBack = backendTriggers.some(field => {
          return currentClassification.hasChange(previousClassification, field.primary, field.secondary)
        })
      } else if (context.state.previousClone == null) {
        sendBack = true;
      } else if (backendTriggers == null) {
        sendBack = true;
      }

      if (!sendBack && frontTriggers != null) {
        let recalculate = false;
        frontTriggers.forEach(trigger => {
          let change = context.state.interimClone == null
            || currentClassification.hasChange(interimClassification, trigger.primary, trigger.secondary);
          if (change) {
            recalculate = true;
            let field = function (displayName) {
              return formData.field(displayName)
            }

            if (trigger.secondary) {
              //table or list
              currentClassification.field(trigger.primary).forEach(row => {
                trigger.targets.forEach(targetField => {
                  try {
                    if (trigger.within) {
                      eval(`row.set('${targetField.secondary}', ${targetField.frontEndScript})`)
                    } else {
                      eval(`formData.set('${targetField.primary}', ${targetField.frontEndScript})`)
                    }
                  } catch (ex) {
                    console.log(`${trigger.primary}>${targetField.secondary}: ${targetField.primary}, ${ex}`)
                  }
                });
              })
            } else {
              //todo: check if different
              trigger.targets.forEach(targetField => {
                try {
                  if (targetField.frontEndScript == 'rowNumber()') {
                    let no = 1;
                    currentClassification.field(trigger.primary).forEach(row => {
                      row.set(targetField.secondary, no);
                      no = no + 1;
                    })
                  } else {
                    eval(`formData.set('${targetField.primary}', ${targetField.frontEndScript})`)
                  }
                } catch (ex) {
                  console.log(`${trigger.primary}: ${targetField.frontEndScript}, ${ex}`)
                }

              })
            }
          }
        })

        if (recalculate) {
          context.state.formData = _.cloneDeep(context.state.formData);
          context.state.interimClone = _.cloneDeep(context.state.formData);
        }
      }

      if (!sendBack && !payload.eventName)
        return;

      let clone = _.cloneDeep(context.state.formData);
      let previousClone = _.cloneDeep(context.state.previousClone);

      if (
        (payload.eventName ||
          (sendBack &&
            JSON.stringify(clone) !== JSON.stringify(context.state.previousClone))) &&
        !context.state.synchronizing
      ) {
        console.log("[SYNC] start synchronize");
        context.state.submissionClone = clone;
        context.state.synchronizing = true;

        try {
          let res = await context.state.client
            .post("/api/Activity/FormSync",
              {
                previousFormData: previousClone,
                formDataChanges: diff(previousClone, clone) || {},
                vectorId: context.state.vectorId,
                locusId: context.state.locusId,
                query: context.state.query,
                events: payload.eventName ? [payload.eventName] : [],
                activityName: payload.activity.name,
                activityId: payload.activity.id
              });

          if (res.data == null || res.data.vectorId != context.state.vectorId) {
            context.state.syncError = false;
            context.state.syncErrorRetry = 0;
            context.state.synchronizing = false;
            return;
          }

          context.state.syncError = false;
          context.state.syncErrorRetry = 0;
          context.state.synchronizing = false;

          //no new changes from formdata
          if (
            JSON.stringify(context.state.formData) ===
            JSON.stringify(context.state.submissionClone)
          ) {
            //apply changes
            console.log("[SYNC] apply changes");

            let formData = context.state.submissionClone;
            formData = patch(formData, res.data.dataChanges);

            context.commit("syncFormData", formData);
            context.commit("syncTriggers", res.data)

            if (context.state.originalForm != null) {
              context.commit('revertForm');
            }
            // console.info('[SYNC] form changes', res.data.formChanges)
            if (res.data.formChanges) {
              //recursive find form element
              // form changes
              res.data.formChanges.forEach(change => {
                // get
                let element = element = commons.findElementById(context.state.form && context.state.form.rows, change.id);
                // set
                if (element) {
                  if (change.visible === true || change.visible === false) {
                    Vue.set(element, 'visible', change.visible);
                  }
                  if (change.required === true || change.required === false) {
                    Vue.set(element, 'required', change.required);
                  }
                  if (change.readOnly === true || change.readOnly === false) {
                    Vue.set(element, 'readOnly', change.readOnly);
                  }
                  if (change.input != null) {
                    Vue.set(element, 'input', change.input);
                  }
                  if (change.optionList != null) {
                    Vue.set(element, 'optionList', change.optionList);
                  }
                }
              });
            }

            if (res.data.interaction && res.data.interaction['message'] != null) {
              alert(res.data.interaction['message']);
            }

            context.state.previousClone = _.cloneDeep(formData);
          } else {
            console.log('signature unmatch')
          }
        } catch (err) {
          context.state.synchronizing = false;
          context.state.syncErrorRetry = context.state.syncErrorRetry + 1;
          context.state.syncError = true;
        }
      }
    },
    async importData(context, payload) {
      return await context.state.client.post(
        "/api/Collection/Import",
        payload);
    },
    async loadDocument({ state }, payload) {
      return await state.client.post('/api/activity/document', payload);
    },
    async submitActivity({ state }, payload) {
      return await state.client.post('/api/activity/', payload);
    },
    async saveUserPreference({ state }, payload) {
      return await state.client.post('/api/Preference', payload);
    },
    updateDocumentId(context, payload) {
      context.commit("updateDocumentId", payload);
    },
    async sendComment({ state }, payload) {
      return await state.client.post('/api/Activity/Comment', payload)
    },
    async retrieveHistory({ state }, payload) {
      return await state.client.get(`/api/activity/history/?id=${payload.id}&history=${payload.history}`)
    }
  }
});